'use client';

import Conditional from '@next-app/components/Conditional';
import { isNotNullOrUndefinedorEmpty } from '@next-app/utils/common-utils';
import getUniqueKey from '@next-app/utils/get-unique-key';

interface LLDropdownOption {
  label: string;
  value: any;
  disabled?: boolean;
}

interface LSDropdownProps {
  labelText: string;
  options: LLDropdownOption[];
  errorMsg?: string;
  name?: string;
  autoComplete?: string;
  automationId?: string;
}

const LLDropdown: React.FC<
  React.InputHTMLAttributes<HTMLSelectElement> & LSDropdownProps
> = ({
  labelText,
  id,
  options,
  onChange,
  value,
  errorMsg,
  name,
  onBlur,
  autoComplete,
  automationId,
}) => {
  return (
    <>
      <div className="form-floating">
        <select
          className={`form-select fw-lighter fs-sm ps-ll-3 ${errorMsg ? 'border-danger' : ''}`}
          id={id}
          value={value}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          {...(isNotNullOrUndefinedorEmpty(autoComplete) && { autoComplete })}
          automation-id={automationId}
        >
          <Conditional if={options?.[0]?.label?.indexOf('Select') === -1}>
            <option value="" disabled>
              Select
            </option>
          </Conditional>
          {options.map((option: LLDropdownOption, index: number) => {
            return (
              <option
                key={getUniqueKey(index, option.label)}
                value={option.value}
                disabled={option.disabled}
              >
                {option.label}
              </option>
            );
          })}
        </select>
        <label htmlFor={id}>{labelText}</label>
      </div>
      <Conditional if={isNotNullOrUndefinedorEmpty(errorMsg)}>
        <div className="invalid-feedback d-block">{errorMsg}</div>
      </Conditional>
    </>
  );
};

export default LLDropdown;
